import React, { useState } from 'react';
import { Shield, AlertTriangle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import C from '../constants/colors';

export default function LoginPage({ onRegister }) {
  const { login } = useAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.message || 'Login failed';
      if (msg === 'trial_expired') {
        setError('Your trial period has ended. Contact support to continue.');
      } else {
        setError(msg === 'Invalid credentials' ? 'Invalid email or password.' : msg);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: C.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        width: '100%', maxWidth: '400px', padding: '0 24px',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '16px',
            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
          }}>
            <Shield size={28} color="#fff" />
          </div>
          <h1 style={{ color: C.textPrimary, fontSize: '24px', fontWeight: 700, margin: 0 }}>
            SafeCheck
          </h1>
          <p style={{ color: C.textMuted, fontSize: '14px', marginTop: '6px' }}>
            Emergency Response Platform
          </p>
        </div>

        {/* Card */}
        <div style={{
          background: C.surface, border: `1px solid ${C.border}`,
          borderRadius: '16px', padding: '32px',
        }}>
          <h2 style={{ color: C.textPrimary, fontSize: '18px', fontWeight: 600, margin: '0 0 24px' }}>
            Sign in to your workspace
          </h2>

          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.1)', border: `1px solid rgba(239,68,68,0.3)`,
              borderRadius: '8px', padding: '12px 14px',
              display: 'flex', alignItems: 'flex-start', gap: '10px',
              marginBottom: '20px',
            }}>
              <AlertTriangle size={16} color={C.red} style={{ flexShrink: 0, marginTop: '1px' }} />
              <span style={{ color: C.red, fontSize: '14px' }}>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', color: C.textSecondary, fontSize: '13px', fontWeight: 500, marginBottom: '6px' }}>
                Email address
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="you@company.com"
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  background: C.surfaceElevated, border: `1px solid ${C.border}`,
                  color: C.textPrimary, fontSize: '14px', outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', color: C.textSecondary, fontSize: '13px', fontWeight: 500, marginBottom: '6px' }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                style={{
                  width: '100%', padding: '10px 12px', borderRadius: '8px',
                  background: C.surfaceElevated, border: `1px solid ${C.border}`,
                  color: C.textPrimary, fontSize: '14px', outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn"
              style={{
                width: '100%', padding: '12px',
                background: loading ? C.textMuted : C.blue,
                border: 'none', borderRadius: '8px',
                color: '#fff', fontSize: '15px', fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', marginTop: '20px' }}>
          <span style={{ color: C.textMuted, fontSize: '13px' }}>No account yet? </span>
          <button
            onClick={onRegister}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.blue, fontSize: '13px', fontWeight: 500 }}
          >
            Create a free demo account →
          </button>
        </p>

        <p style={{ textAlign: 'center', color: C.textMuted, fontSize: '12px', marginTop: '12px' }}>
          SafeCheck LivePOB v2 · Powered by bakirsoft
        </p>
      </div>
    </div>
  );
}
